module.exports = __webpack_public_path__ + "static/media/logo_republica.08cabe57.svg";